import React from "react";
import { Slider as DebtSlider } from "@mui/material";
import { Button } from "@DR/components/common";

const Step1 = ({
  handleSliderChange,
  setFormError,
  formError,
  debtValue,
  values,
  setStep,
  step,
  marksMobile,
}) => {
  const boxShadow =
    "0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.13),0 0 0 1px rgba(0,0,0,0.02)";
  const formatNumber = (text) => {
    return text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  return (
    <div className="bg-white p-8 rounded-3xl">
      <h2 className="text-2xl text-custom-orange font-bold">
        How Much Debt Do you Owe?
      </h2>
      <div className="my-4">
        <h2 className="text-[#023c6e] text-center text-6xl font-bold my-3">
          ${formatNumber(debtValue)}
        </h2>
        <div className="px-4 text-center">
          <DebtSlider
            defaultValue={63000}
            min={10000}
            max={300000}
            marks={marksMobile}
            step={1000}
            onChange={handleSliderChange}
            sx={{
              fontSize: "1.0rem",
              color: "rgba(27, 151, 106, 0.64)",
              "& .MuiSlider-thumb": {
                color: "white",
                height: 30,
                width: 30,
                boxShadow: boxShadow,
                "&:focus, &:hover, &.Mui-active": {
                  boxShadow:
                    "0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.3),0 0 0 1px rgba(0,0,0,0.02)",
                  // Reset on touch devices, it doesn't add specificity
                  "@media (hover: none)": {
                    boxShadow: boxShadow,
                  },
                },
              },
              "& .MuiSlider-track": {
                height: 12,
                backgroundColor: "orange",
                border: "none",
              },
              "& .MuiSlider-rail": {
                height: 12,
                backgroundColor: "orange",
                border: "none",
              },
            }}
          />
        </div>
      </div>
      {formError.debtValue ? (
        <p className="w-full flex justify-center items-center my-4 text-lg font-semibold text-custom-negative">
          {formError.debtValue}
        </p>
      ) : null}
      {/* <h5 className="text-custom-primary text-xl sm:text-2xl mt-3 mb-5">
        Select Your Debt Amount
      </h5> */}
      <Button
        className="!bg-[#023c6e] !py-2 !px-3 !rounded-lg !text-xl !font-bold mx-auto"
        label="My FREE Debt Assessment"
        variant="primary"
        onPress={() => {
          if (values.debtValue) {
            if (step < 3) setStep(step + 1);
          } else {
            setFormError({
              ...formError,
              debtValue: "Please select a debt amount.",
            });
          }
        }}
      />
      <div className="flex items-center justify-center mt-8">
        <img src="/images/caller.webp" className="w-auto h-16" alt="Customer" />
        <div>
          <p className={`text-[#023c6e] text-3xl font-bold`}>800-971-4060</p>
          <p className="sm:mt-2 text-[#023c6e] text-xs font-semibold">
            or Talk to a Texas Debt Specialist
          </p>
        </div>
      </div>
    </div>
  );
};

export default Step1;
